import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";

export const useStudentBio = () => {
  const { data, isSuccess } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
    staleTime: Infinity,
  });

  return {
    nis: data?.data?.nis ?? "",
    gender: data?.data?.gender ?? "",
    nama: data?.data?.nama ?? "",
    isSuccess,
    rawData: data?.data,
  };
};
